import React, { Component } from 'react'
import { Button, Input, Modal, Select, Table } from 'antd'
import { Redirect } from 'react-router-dom'
import _ from 'lodash'

import './DocumentListModal.scss'

const { Search } = Input
const { Option } = Select

export default class DocumentListModal extends Component {
    constructor(props) {
        super(props)

        this.state = {
            dataset: [],
            filter: {},
            searchBarInput: '',
            redirect: false,
            selectedRowIdx: null
        }

        this.handleRowClick = this.handleRowClick.bind(this)
        this.handleBtnClick = this.handleBtnClick.bind(this)
        this.handleSearchBarInputChange = this.handleSearchBarInputChange.bind(this)
        this.handleSearchBarSearch = this.handleSearchBarSearch.bind(this)
    }

    filterProject() {
        const { filter, searchBarInput } = this.state
        let newProjectList = _.cloneDeep(this.props.listDataSource)
        let filterCondition = {}

        _.forEach(filter, (value, key) => {
            if (value && key !== 'size') {
                filterCondition[_.snakeCase(key)] = value
            }
        })

        newProjectList = _.filter(newProjectList, filterCondition)

        if (filter.size) {
            switch (filter.size) {
                case '<= 300':
                    newProjectList = _.filter(newProjectList, (project) => project.size <= 300)
                    break
                case '301 - 500':
                    newProjectList = _.filter(newProjectList, (project) => project.size > 300 && project.size <= 500)
                    break
                case '501 - 800':
                    newProjectList = _.filter(newProjectList, (project) => project.size > 500 && project.size <= 800)
                    break
                case '> 800':
                    newProjectList = _.filter(newProjectList, (project) => project.size > 800)
                    break
                default:
            }
        }

        newProjectList = _.filter(newProjectList, (project) => {
            return _.filter(_.map(_.values(project), (value) => value ? value.toString().toUpperCase() : ''), (value) => value.indexOf(searchBarInput.toUpperCase()) !== -1).length !== 0
        })

        this.setState({ dataset: newProjectList })
    }

    handleFilterChange(field, value) {
        let newFilter = _.cloneDeep(this.state.filter)
        newFilter[field] = value

        this.setState({ filter: newFilter })
    }

    handleSearchBarInputChange(e) {
        this.setState({ searchBarInput: e.target.value })
    }

    handleSearchBarSearch(value) {
        this.filterProject()
    }

    handleRowClick(record, idx) {
        this.setState({ selectedRowIdx: idx })
    }

    handleBtnClick() {
        const { beforeCreateNewProject, modalRedirect } = this.props
        const { selectedRowIdx } = this.state
        if (modalRedirect) {
            beforeCreateNewProject(selectedRowIdx)
            this.setState({ redirect: true })
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { visible, listDataSource, selectedRowIdx } = this.props
        const { filter, searchBarInput } = this.state

        if (prevProps.selectedRowIdx !== selectedRowIdx && selectedRowIdx != null) {
            this.setState({ selectedRowIdx })
        }

        if (!_.isEqual(prevProps.listDataSource, listDataSource)) {
            this.setState({ dataset: listDataSource, selectedRowIdx: null })
        }

        if (!_.isEqual(prevProps.filter, this.props.filter)) {
            this.setState({ filter: this.props.filter })
        }

        if (prevProps.searchBarInput !== this.props.searchBarInput && this.props.searchBarInput) {
            this.setState({ searchBarInput: this.props.searchBarInput })
        }

        if (prevProps.visible !== visible && visible && searchBarInput) {
            this.filterProject()
        }

        if (!_.isEqual(prevState.filter, filter)) {
            this.filterProject()
            this.setState({ selectedRowIdx: null })
        }
    }

    render() {
        const { visible, onCancel, listParentColumns, modalBtnText, modalRedirect, selectedDocumentType, locationList, estateList } = this.props
        const { dataset, filter, searchBarInput, redirect, selectedRowIdx } = this.state
        const { category, type, size, siteLocation, estateName } = filter


        if (redirect)
            return <Redirect to={modalRedirect(dataset[selectedRowIdx]._id, selectedDocumentType)}/>
        else
            return (
                <Modal
                    width="60%"
                    wrapClassName="DocumentListModal"
                    visible={visible}
                    footer={null}
                    onCancel={onCancel}
                >
                    <p className="label">Please choose a project to attach your new document:</p>
                    <div className="filter">
                        <Select 
                            placeholder="Category" 
                            dropdownMatchSelectWidth={false} 
                            value={category}
                            onChange={this.handleFilterChange.bind(this, 'category')}
                            allowClear
                        >
                            <Option value="RE">RE</Option>
                            <Option value="OF">OF</Option>
                            <Option value="MI">MI</Option>
                        </Select>
                        <Select 
                            placeholder="Type" 
                            dropdownMatchSelectWidth={false} 
                            value={type}
                            onChange={this.handleFilterChange.bind(this, 'type')}
                            allowClear
                        >
                            <Option value="Apartment">Apartment</Option>
                            <Option value="House">House</Option>
                            <Option value="Subdivided Flat">Subdivided Flat</Option>
                            <Option value="Shop">Shop</Option>
                            <Option value="NGO">NGO</Option>
                            <Option value="Restaurant">Restaurant</Option>
                            <Option value="Elderly House">Elderly House</Option>
                            <Option value="School">School</Option>
                            <Option value="Office">Office</Option>
                        </Select>
                        <Select 
                            placeholder="Size" 
                            dropdownMatchSelectWidth={false} 
                            value={size}
                            onChange={this.handleFilterChange.bind(this, 'size')}
                            allowClear
                        >
                            <Option value="< 300">&lt; 300</Option>
                            <Option value="301 - 500">301 - 500</Option>
                            <Option value="501 - 800">501 - 800</Option>
                            <Option value="> 800">&gt; 800</Option>
                        </Select>
                        <Select 
                            placeholder="Location" 
                            dropdownMatchSelectWidth={false} 
                            value={siteLocation}
                            onChange={this.handleFilterChange.bind(this, 'siteLocation')}
                            allowClear
                        >
                            {
                                _.map(locationList, (location, i) => (
                                    <Option key={location} value={location}>{location}</Option>
                                ))
                            }
                        </Select>
                        <Select 
                            placeholder="Estate" 
                            dropdownMatchSelectWidth={false} 
                            value={estateName}
                            onChange={this.handleFilterChange.bind(this, 'estateName')}
                            allowClear
                        >
                            {
                                _.map(estateList, (estate, i) => (
                                    <Option key={estate} value={estate}>{estate}</Option>
                                ))
                            }
                        </Select>
                        <Search 
                            placeholder="Search Bar" 
                            value={searchBarInput}
                            onChange={this.handleSearchBarInputChange}
                            onSearch={this.handleSearchBarSearch}
                        />
                    </div>
                    <div className="document-list">
                        <Table 
                            className="document-table"
                            rowKey={'_id'}
                            columns={listParentColumns}
                            dataSource={dataset}
                            showHeader={false}
                            pagination={false}
                            size="middle"
                            scroll={{y: 250}}
                            onRowClick={this.handleRowClick}
                            rowClassName={(record, idx) => idx === selectedRowIdx ? 'selected' : ''}
                        />
                    </div>
                    <div className="footer">
                        <Button type="primary" size="large" onClick={this.handleBtnClick} disabled={selectedRowIdx == null}>{modalBtnText}</Button>
                    </div>
                </Modal>
            )
    }
}



// WEBPACK FOOTER //
// ./src/Commons/DocumentListModal/DocumentListModal.js